// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
    baseApi: 'https://onecgapi.cloudcx.ai',
 homeDescription: 'A unique tool which gives you flexibility and helps you to manage your contact centre more efficiently Fully automated One- Click Admiration for Geneseys.',
  recaptchaSiteKey: '6LfI5HwsAAAAAO0dr6a4KYfa3xqdtwl4dYWaes_k'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
